<template lang="html">
  <div :class="['page', {}]" id="home">
    <transition name="fade">
      <div class="page wrapper" v-if="loaded">
        <the-header></the-header>
        <router-view></router-view>
      </div>
      <splash v-else></splash>
    </transition>
  </div>
</template>

<script>
import Splash from './home/Splash.vue'
import TheHeader from '../components/common/TheHeader'
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next($this => {
      if ($this.$route.matched.length === 1) next({ name: 'create' })
      else next()
    })
  },
  beforeMount () {
  },
  computed: {
    ...mapGetters([
      'loaded'
    ])
  },
  mounted () {},
  methods: {
  },
  components: {
    Splash,
    TheHeader
  }
}
</script>
<style lang="scss" type="text/css" media="screen"></style>
